export default "__VITE_ASSET__C53k$NNv__"